import { Container, Typography } from '@cleartrip/ct-design-components'

import { STUDENT_BADGE_TEXT } from '@/constants/Srp'

const PtcBadge = () => {
  return (
    <Container
      className={`bg-trip-blue br-4`}
      paddingBottom='4px'
      paddingLeft='6px'
      paddingRight='6px'
      paddingTop='4px'
    >
      <Typography color='neutral' variant='TAG'>
        {STUDENT_BADGE_TEXT}
      </Typography>
    </Container>
  )
}

export default PtcBadge
